import apiClient from './apiClient';

// ============================================
// Types
// ============================================

export type CampaignStatus = 'DRAFT' | 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'CANCELED';

export interface Campaign {
    id: string;
    salonId: string;
    name: string;
    messageTemplate: string;
    scheduledAt: string | null;
    status: CampaignStatus;
    sentCount: number;
    failedCount: number;
    totalRecipients: number;
    clientGroupId?: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface CreateCampaignRequest {
    name: string;
    messageTemplate: string;
    scheduledAt?: string | null;
    groupId?: string | null;
}

// ============================================
// API
// ============================================

export const campaignApi = {
    getCampaigns: async (salonId: string): Promise<Campaign[]> => {
        const response = await apiClient.get<Campaign[]>(`/salon/${salonId}/campaigns`);
        return response.data;
    },

    createCampaign: async (salonId: string, data: CreateCampaignRequest): Promise<Campaign> => {
        const response = await apiClient.post<Campaign>(`/salon/${salonId}/campaigns`, data);
        return response.data;
    },

    scheduleCampaign: async (salonId: string, campaignId: string): Promise<Campaign> => {
        const response = await apiClient.post<Campaign>(`/salon/${salonId}/campaigns/${campaignId}/schedule`);
        return response.data;
    },
};
